module.exports = __webpack_public_path__ + "static/media/klickexcardau.b5b32765.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/klickexcardau.png
// module id = 5996
// module chunks = 1